var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "liquidity-add-area" },
    [
      _c("WindowModal", {
        attrs: { title: _vm.modalTitle, type: "Global" },
        scopedSlots: _vm._u([
          {
            key: "modal-content",
            fn: function () {
              return [
                _c("SupplyLiquidity", {
                  ref: "supplyLiquidity",
                  attrs: {
                    pair: _vm.pair,
                    "pair-data": _vm.pairData,
                    transaction: _vm.transaction,
                  },
                  on: {
                    provideLiquidity: _vm.provideLiquidity,
                    initConfirmState: function ($event) {
                      return _vm.changeModalTitle("init")
                    },
                    initLoading: function ($event) {
                      return _vm.changeModalTitle("loading")
                    },
                    initSuccess: function ($event) {
                      return _vm.changeModalTitle("success")
                    },
                    initError: function ($event) {
                      return _vm.changeModalTitle("error")
                    },
                    closeGlobalModal: _vm.closeModal,
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("section", { staticClass: "liquidity-content" }, [
        _c("div", { staticClass: "header-area" }, [
          _c(
            "div",
            { staticClass: "header-item" },
            [
              _c(
                "nuxt-link",
                {
                  staticClass: "back-button",
                  attrs: { to: _vm.localePath("/liquidity") },
                },
                [_c("ArrowBack")],
                1
              ),
              _vm._v(" "),
              _c("h1", [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("liquidity.h1")) + "\n        "
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { ref: "settingsButton", staticClass: "settings" }, [
            _c(
              "div",
              { staticClass: "toggler", on: { click: _vm.toggleSettings } },
              [_c("Cog")],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subheader-area" }, [
          _c("div", { staticClass: "h2" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("liquidity.select_pair")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn cyan btn-outline",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.clearForm(true)
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("liquidity.clear_all")) +
                  "\n      "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tokens-area" }, [
          _c("div", { staticClass: "token-item" }, [
            _c(
              "div",
              {
                ref: "fromListButton",
                staticClass: "token-select",
                on: { click: _vm.toggleFromList },
              },
              [
                _vm.fromToken === null
                  ? _c("div", { staticClass: "token-data" }, [
                      _c("div", { staticClass: "token-area" }, [
                        _c("div", { staticClass: "empty-area" }),
                        _vm._v(" "),
                        _c("p", { staticClass: "normal" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("liquidity.select_token")) +
                              "\n              "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "chevron-area" },
                        [_c("ChevronDown")],
                        1
                      ),
                    ])
                  : _c("div", { staticClass: "token-data" }, [
                      _c(
                        "div",
                        { staticClass: "token-area" },
                        [
                          _c("nuxt-img", {
                            attrs: {
                              preset: "tokenBigLogo",
                              src:
                                _vm.fromToken.address !== _vm.$config.ZERO
                                  ? _vm.$getImageByAddress(
                                      _vm.fromToken.address
                                    )
                                  : _vm.$getImage(_vm.fromToken.logoURI),
                              alt: _vm.fromToken.name,
                              title: _vm.fromToken.symbol,
                            },
                            on: {
                              error: function ($event) {
                                $event.target.src = require("~/static/img/default_token.svg")
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.fromToken.symbol) +
                                "\n              "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "chevron-area" },
                        [_c("ChevronDown")],
                        1
                      ),
                    ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { ref: "fromList", staticClass: "token-select-list" },
              [
                _c("div", { staticClass: "h4" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("swap.select_token")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "form",
                  { staticClass: "search-area", attrs: { method: "POST" } },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "search-button",
                        attrs: {
                          type: "button",
                          "arira-label": _vm.$t("common.search"),
                        },
                      },
                      [_c("Search")],
                      1
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.search,
                          expression: "search",
                        },
                      ],
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("common.search") + "...",
                      },
                      domProps: { value: _vm.search },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.search = $event.target.value
                        },
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("TokensList", {
                  attrs: {
                    "current-token": _vm.pair.from_token,
                    "pair-token": _vm.pair.to_token,
                    list: _vm.computedList,
                  },
                  on: { pick: _vm.selectFromToken },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "manageFromButton",
                    staticClass: "open-manage",
                    on: { click: _vm.toggleManageFrom },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("swap.manage")) +
                        "\n          "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("ManageModal", {
                  ref: "manageFromArea",
                  attrs: { active: _vm.activeManageFrom },
                  on: { toggle: _vm.toggleManageFrom },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "swap-area" }, [
            _c("div", { staticClass: "swap-button" }, [_c("Plus")], 1),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { class: { "token-item": true, disabled: _vm.tokenFixed } },
            [
              _c(
                "div",
                {
                  ref: "toListButton",
                  staticClass: "token-select",
                  on: {
                    click: function ($event) {
                      return _vm.toggleToList()
                    },
                  },
                },
                [
                  _vm.toToken === null
                    ? _c("div", { staticClass: "token-data" }, [
                        _c("div", { staticClass: "token-area" }, [
                          _c("div", { staticClass: "empty-area" }),
                          _vm._v(" "),
                          _c("p", { staticClass: "normal" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("liquidity.select_token")) +
                                "\n              "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "chevron-area" },
                          [_c("ChevronDown")],
                          1
                        ),
                      ])
                    : _c("div", { staticClass: "token-data" }, [
                        _c(
                          "div",
                          { staticClass: "token-area" },
                          [
                            _c("nuxt-img", {
                              attrs: {
                                preset: "tokenBigLogo",
                                src:
                                  _vm.toToken.address !== _vm.$config.ZERO
                                    ? _vm.$getImageByAddress(
                                        _vm.toToken.address
                                      )
                                    : _vm.$getImage(_vm.toToken.logoURI),
                                alt: _vm.toToken.name,
                                title: _vm.toToken.symbol,
                              },
                              on: {
                                error: function ($event) {
                                  $event.target.src = require("~/static/img/default_token.svg")
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.toToken.symbol) +
                                  "\n              "
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "chevron-area" },
                          [_c("ChevronDown")],
                          1
                        ),
                      ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { ref: "toList", staticClass: "token-select-list" },
                [
                  _c("div", { staticClass: "h4" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("swap.select_token")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    { staticClass: "search-area", attrs: { method: "POST" } },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "search-button",
                          attrs: {
                            type: "button",
                            "arira-label": _vm.$t("common.search"),
                          },
                        },
                        [_c("Search")],
                        1
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.search,
                            expression: "search",
                          },
                        ],
                        attrs: {
                          type: "text",
                          placeholder: _vm.$t("common.search") + "...",
                        },
                        domProps: { value: _vm.search },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.search = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("TokensList", {
                    attrs: {
                      "current-token": _vm.pair.to_token,
                      "pair-token": _vm.pair.from_token,
                      list: _vm.computedList,
                    },
                    on: { pick: _vm.selectToToken },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "manageToButton",
                      staticClass: "open-manage",
                      on: { click: _vm.toggleManageTo },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("swap.manage")) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("ManageModal", {
                    ref: "manageToArea",
                    attrs: { active: _vm.activeManageTo },
                    on: { toggle: _vm.toggleManageTo },
                  }),
                ],
                1
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { class: { "information-area": true, disabled: !_vm.tokensPicked } },
          [
            _c("div", { staticClass: "price-range-area" }, [
              _c("div", { staticClass: "h2" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("liquidity.set_price_range")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-area" }, [
                _c("div", { staticClass: "text-area" }, [
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("liquidity.set_price_range_desc")) +
                        "\n              "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://medium.com/gamma-strategies/expected-price-range-strategies-in-uniswap-v3-833dff253f84",
                          target: "_blank",
                          rel: "nofollow noopener norefferer",
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("liquidity.set_price_range_link")) +
                            "\n              "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "range-switch-area" }, [
                  _c(
                    "div",
                    {
                      class: {
                        "switch-item": true,
                        active: _vm.priceSettings === "from",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectPriceSettings("from")
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.pair.from_token !== null
                                ? _vm.pair.from_token.symbol.toUpperCase()
                                : "..."
                            ) +
                            "\n              "
                        ),
                      ]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.price")) + "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "switch-item": true,
                        active: _vm.priceSettings === "to",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectPriceSettings("to")
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.pair.to_token !== null
                                ? _vm.pair.to_token.symbol.toUpperCase()
                                : "..."
                            ) +
                            "\n              "
                        ),
                      ]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.price")) + "\n            "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "prices-area" }, [
              _vm.priceSettings === "from"
                ? _c(
                    "div",
                    { ref: "fromPriceSettings", staticClass: "positions" },
                    [
                      _c("div", { staticClass: "position-area" }, [
                        _c("div", { staticClass: "h2" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("liquidity.min_price")) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "subheader" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.pair.from_token !== null
                                  ? _vm.pair.from_token.symbol.toUpperCase()
                                  : "..."
                              )
                            ),
                          ]),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("common.per")) +
                              "\n              "
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.pair.to_token !== null
                                  ? _vm.pair.to_token.symbol.toUpperCase()
                                  : "..."
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "position" }, [
                          _c("div", { staticClass: "number-area" }, [
                            _c("p", { staticClass: "percent" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.liquidityMinFromValue) +
                                  "\n                "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "buttons-area" }, [
                            _c(
                              "button",
                              {
                                class: {
                                  "btn cyan btn-outline": true,
                                  disabled:
                                    _vm.pair.from_value === null ||
                                    _vm.pair.from_value <= 0 ||
                                    _vm.liquidity.min_price_from <= 0,
                                },
                                attrs: { type: "button" },
                                on: { click: _vm.minusMinFromPercnet },
                              },
                              [
                                _vm._v(
                                  "\n                  -" +
                                    _vm._s(_vm.liquidity.fee) +
                                    "%\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                class: {
                                  "btn cyan btn-outline": true,
                                  disabled:
                                    _vm.pair.from_value === null ||
                                    _vm.pair.from_value <= 0,
                                },
                                attrs: { type: "button" },
                                on: { click: _vm.addMinFromPercnet },
                              },
                              [
                                _vm._v(
                                  "\n                  +" +
                                    _vm._s(_vm.liquidity.fee) +
                                    "%\n                "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "position-area" }, [
                        _c("div", { staticClass: "h2" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("liquidity.max_price")) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "subheader" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.pair.from_token !== null
                                  ? _vm.pair.from_token.symbol.toUpperCase()
                                  : "..."
                              )
                            ),
                          ]),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("common.per")) +
                              "\n              "
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.pair.to_token !== null
                                  ? _vm.pair.to_token.symbol.toUpperCase()
                                  : "..."
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "position" }, [
                          _c("div", { staticClass: "number-area" }, [
                            _c("p", { staticClass: "percent" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.liquidityMaxFromValue) +
                                  "\n                "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "buttons-area" }, [
                            _c(
                              "button",
                              {
                                class: {
                                  "btn cyan btn-outline": true,
                                  disabled:
                                    _vm.pair.from_value === null ||
                                    _vm.pair.from_value <= 0 ||
                                    _vm.liquidity.min_price_from <= 0,
                                },
                                attrs: { type: "button" },
                                on: { click: _vm.minusMaxFromPercnet },
                              },
                              [
                                _vm._v(
                                  "\n                  -" +
                                    _vm._s(_vm.liquidity.fee) +
                                    "%\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                class: {
                                  "btn cyan btn-outline": true,
                                  disabled:
                                    _vm.pair.from_value === null ||
                                    _vm.pair.from_value <= 0,
                                },
                                attrs: { type: "button" },
                                on: { click: _vm.addMaxFromPercnet },
                              },
                              [
                                _vm._v(
                                  "\n                  +" +
                                    _vm._s(_vm.liquidity.fee) +
                                    "%\n                "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.priceSettings === "to"
                ? _c(
                    "div",
                    { ref: "toPriceSettings", staticClass: "positions" },
                    [
                      _c("div", { staticClass: "position-area" }, [
                        _c("div", { staticClass: "h2" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("liquidity.min_price")) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "subheader" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.pair.to_token !== null
                                  ? _vm.pair.to_token.symbol.toUpperCase()
                                  : "..."
                              )
                            ),
                          ]),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("common.per")) +
                              "\n              "
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.pair.from_token !== null
                                  ? _vm.pair.from_token.symbol.toUpperCase()
                                  : "..."
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "position" }, [
                          _c("div", { staticClass: "number-area" }, [
                            _c("p", { staticClass: "percent" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.liquidityMinToValue) +
                                  "\n                "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "buttons-area" }, [
                            _c(
                              "button",
                              {
                                class: {
                                  "btn cyan btn-outline": true,
                                  disabled:
                                    _vm.pair.to_value === null ||
                                    _vm.pair.to_value <= 0 ||
                                    _vm.liquidity.min_price_to <= 0,
                                },
                                attrs: { type: "button" },
                                on: { click: _vm.minusMinToPercnet },
                              },
                              [
                                _vm._v(
                                  "\n                  -" +
                                    _vm._s(_vm.liquidity.fee) +
                                    "%\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                class: {
                                  "btn cyan btn-outline": true,
                                  disabled:
                                    _vm.pair.to_value === null ||
                                    _vm.pair.to_value <= 0,
                                },
                                attrs: { type: "button" },
                                on: { click: _vm.addMinToPercnet },
                              },
                              [
                                _vm._v(
                                  "\n                  +" +
                                    _vm._s(_vm.liquidity.fee) +
                                    "%\n                "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "position-area" }, [
                        _c("div", { staticClass: "h2" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("liquidity.max_price")) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "subheader" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.pair.to_token !== null
                                  ? _vm.pair.to_token.symbol.toUpperCase()
                                  : "..."
                              )
                            ),
                          ]),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("common.per")) +
                              "\n              "
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.pair.from_token !== null
                                  ? _vm.pair.from_token.symbol.toUpperCase()
                                  : "..."
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "position" }, [
                          _c("div", { staticClass: "number-area" }, [
                            _c("p", { staticClass: "percent" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.liquidityMaxToValue) +
                                  "\n                "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "buttons-area" }, [
                            _c(
                              "button",
                              {
                                class: {
                                  "btn cyan btn-outline": true,
                                  disabled:
                                    _vm.pair.to_value === null ||
                                    _vm.pair.to_value <= 0 ||
                                    _vm.liquidity.min_price_to <= 0,
                                },
                                attrs: { type: "button" },
                                on: { click: _vm.minusMaxToPercnet },
                              },
                              [
                                _vm._v(
                                  "\n                  -" +
                                    _vm._s(_vm.liquidity.fee) +
                                    "%\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                class: {
                                  "btn cyan btn-outline": true,
                                  disabled:
                                    _vm.pair.to_value === null ||
                                    _vm.pair.to_value <= 0,
                                },
                                attrs: { type: "button" },
                                on: { click: _vm.addMaxToPercnet },
                              },
                              [
                                _vm._v(
                                  "\n                  +" +
                                    _vm._s(_vm.liquidity.fee) +
                                    "%\n                "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "h2" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("liquidity.deposit_amounts")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "deposited-tokens" }, [
              _c("div", { staticClass: "token-area" }, [
                _vm.pair.from_token.symbol.length === 0
                  ? _c("div", { staticClass: "token-data" }, [
                      _c("div", { staticClass: "token" }, [
                        _c("div", { staticClass: "empty-area" }),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("liquidity.select_token")) +
                              "\n              "
                          ),
                        ]),
                      ]),
                    ])
                  : _c("div", { staticClass: "token-data" }, [
                      _c(
                        "div",
                        { staticClass: "token" },
                        [
                          _c("nuxt-img", {
                            attrs: {
                              preset: "tokenBigLogo",
                              src:
                                _vm.fromToken.address !== _vm.$config.ZERO
                                  ? _vm.$getImageByAddress(
                                      _vm.fromToken.address
                                    )
                                  : _vm.$getImage(_vm.fromToken.logoURI),
                              alt: _vm.fromToken.name,
                              title: _vm.fromToken.symbol,
                            },
                            on: {
                              error: function ($event) {
                                $event.target.src = require("~/static/img/default_token.svg")
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.fromToken.symbol) +
                                "\n              "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: {
                            "copy-area": true,
                            active:
                              _vm.fromToken.address.length > 0 &&
                              _vm.fromToken.address !== _vm.$config.ZERO,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "svg-area",
                              attrs: { tooltip: _vm.copyText },
                              on: {
                                click: function ($event) {
                                  return _vm.copyAddress(
                                    $event,
                                    _vm.fromToken.address
                                  )
                                },
                              },
                            },
                            [_c("Copy")],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "svg-area",
                              attrs: {
                                tooltip: _vm.$t("common.add_to_metamask"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$addToMetamask(_vm.fromToken)
                                },
                              },
                            },
                            [_c("MetamaskIcon")],
                            1
                          ),
                        ]
                      ),
                    ]),
                _vm._v(" "),
                _c("div", { staticClass: "token-price" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.pair.from_value,
                        expression: "pair.from_value",
                      },
                    ],
                    staticClass: "amount-input",
                    attrs: {
                      type: "number",
                      step: "0.000001",
                      min: "0",
                      lang: "en",
                    },
                    domProps: { value: _vm.pair.from_value },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.pair, "from_value", $event.target.value)
                        },
                        _vm.inputFrom,
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _vm.pair.from_value_usd !== undefined &&
                  _vm.pair.from_value_usd !== 0
                    ? _c("div", { staticClass: "usd-price" }, [
                        _vm._v(
                          "\n              ≈ $" +
                            _vm._s(
                              _vm.$priceFormat(
                                _vm.pair.from_value_usd *
                                  parseFloat(_vm.pair.from_value),
                                2
                              )
                            ) +
                            "\n            "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fromToken !== null && _vm.fromToken.address.length > 0
                    ? _c("p", { staticClass: "available" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("swap.available")) +
                            ":\n              "
                        ),
                        _vm.fromToken.balance !== undefined &&
                        _vm.fromToken.balance !== null
                          ? _c("span", { staticClass: "bold" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$formatCryptoAmount(
                                    parseFloat(_vm.fromToken.balance),
                                    4
                                  )
                                )
                              ),
                            ])
                          : _c("span", { staticClass: "bold" }, [_vm._v("0")]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "max-button": true,
                        active:
                          _vm.fromToken !== null &&
                          _vm.fromToken.address.length > 0,
                      },
                      on: { click: _vm.setFromMax },
                    },
                    [
                      _c("p", { staticClass: "text" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("swap.max")) +
                            "\n              "
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "swap-area" }, [
                _c("div", { staticClass: "swap-button" }, [_c("Plus")], 1),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "token-area" }, [
                _vm.pair.to_token.symbol.length === 0
                  ? _c("div", { staticClass: "token-data" }, [
                      _c("div", { staticClass: "token" }, [
                        _c("div", { staticClass: "empty-area" }),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("liquidity.select_token")) +
                              "\n              "
                          ),
                        ]),
                      ]),
                    ])
                  : _c("div", { staticClass: "token-data" }, [
                      _c(
                        "div",
                        { staticClass: "token" },
                        [
                          _c("nuxt-img", {
                            attrs: {
                              preset: "tokenBigLogo",
                              src:
                                _vm.toToken.address !== _vm.$config.ZERO
                                  ? _vm.$getImageByAddress(_vm.toToken.address)
                                  : _vm.$getImage(_vm.toToken.logoURI),
                              alt: _vm.toToken.name,
                              title: _vm.toToken.symbol,
                            },
                            on: {
                              error: function ($event) {
                                $event.target.src = require("~/static/img/default_token.svg")
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.toToken.symbol) +
                                "\n              "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: {
                            "copy-area": true,
                            active:
                              _vm.toToken.address.length > 0 &&
                              _vm.toToken.address !== _vm.$config.ZERO,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "svg-area",
                              attrs: { tooltip: _vm.copyText },
                              on: {
                                click: function ($event) {
                                  return _vm.copyAddress(
                                    $event,
                                    _vm.toToken.address
                                  )
                                },
                              },
                            },
                            [_c("Copy")],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "svg-area",
                              attrs: {
                                tooltip: _vm.$t("common.add_to_metamask"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$addToMetamask(_vm.toToken)
                                },
                              },
                            },
                            [_c("MetamaskIcon")],
                            1
                          ),
                        ]
                      ),
                    ]),
                _vm._v(" "),
                _c("div", { staticClass: "token-price" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.pair.to_value,
                        expression: "pair.to_value",
                      },
                    ],
                    staticClass: "amount-input",
                    attrs: {
                      type: "number",
                      step: "0.000001",
                      min: "0",
                      lang: "en",
                    },
                    domProps: { value: _vm.pair.to_value },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.pair, "to_value", $event.target.value)
                        },
                        _vm.inputTo,
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _vm.pair.to_value_usd !== undefined &&
                  _vm.pair.to_value_usd !== 0
                    ? _c("div", { staticClass: "usd-price" }, [
                        _vm._v(
                          "\n              ≈ $" +
                            _vm._s(
                              _vm.$priceFormat(
                                _vm.pair.to_value_usd *
                                  parseFloat(_vm.pair.to_value),
                                2
                              )
                            ) +
                            "\n            "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.toToken !== null && _vm.toToken.address.length > 0
                    ? _c("p", { staticClass: "available" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("swap.available")) +
                            ":\n              "
                        ),
                        _vm.toToken.balance !== undefined &&
                        _vm.toToken.balance !== null
                          ? _c("span", { staticClass: "bold" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$formatCryptoAmount(
                                    parseFloat(_vm.toToken.balance),
                                    4
                                  )
                                )
                              ),
                            ])
                          : _c("span", { staticClass: "bold" }, [_vm._v("0")]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "max-button": true,
                        active:
                          _vm.toToken !== null &&
                          _vm.toToken.address.length > 0,
                      },
                      on: { click: _vm.setToMax },
                    },
                    [
                      _c("p", { staticClass: "text" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("swap.max")) +
                            "\n              "
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                class: { "pair-info": true, "mb-0": _vm.errorText.length > 0 },
              },
              [
                _c("div", { staticClass: "info-item" }, [
                  _c("div", { staticClass: "percent" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.pairData !== null
                            ? _vm.$formatCryptoAmount(
                                _vm.pairData.reserves.reserve0 /
                                  _vm.pairData.reserves.reserve1,
                                6
                              )
                            : _vm.$t("liquidity.tbd")
                        ) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tokens" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.pair.from_token !== null
                            ? _vm.pair.from_token.symbol.toUpperCase()
                            : "..."
                        )
                      ),
                    ]),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.per")) +
                        "\n            "
                    ),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.pair.to_token !== null
                            ? _vm.pair.to_token.symbol.toUpperCase()
                            : "..."
                        )
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-item" }, [
                  _c("div", { staticClass: "percent" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.pairData !== null
                            ? _vm.$formatCryptoAmount(
                                _vm.pairData.reserves.reserve1 /
                                  _vm.pairData.reserves.reserve0,
                                6
                              )
                            : _vm.$t("liquidity.tbd")
                        ) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tokens" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.pair.to_token !== null
                            ? _vm.pair.to_token.symbol.toUpperCase()
                            : "..."
                        )
                      ),
                    ]),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.per")) +
                        "\n            "
                    ),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.pair.from_token !== null
                            ? _vm.pair.from_token.symbol.toUpperCase()
                            : "..."
                        )
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-item" }, [
                  _c("div", { staticClass: "percent" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.pairData !== null
                            ? _vm.$priceFormat(
                                _vm.calculatedPoolShare,
                                2,
                                ".",
                                ","
                              ) + "%"
                            : _vm.$t("liquidity.tbd")
                        ) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tokens" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("liquidity.share_of_pool")) +
                        "\n          "
                    ),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: {
                  "warning-area": true,
                  active: _vm.errorText.length > 0,
                },
              },
              [
                _c("div", { staticClass: "icon-area" }, [_c("Warn")], 1),
                _vm._v(" "),
                _c("div", { staticClass: "text-area" }, [
                  _vm._v("\n          " + _vm._s(_vm.errorText) + "\n        "),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "buttons-area" }, [
              _vm.user !== undefined && _vm.user !== null
                ? _c(
                    "button",
                    {
                      class: {
                        "btn cyan": true,
                        disabled:
                          !_vm.liquidityPicked ||
                          _vm.lowBalances ||
                          _vm.supplyCtaDisabled ||
                          _vm.loading,
                      },
                      attrs: {
                        type: "button",
                        disabled:
                          !_vm.liquidityPicked ||
                          _vm.lowBalances ||
                          _vm.supplyCtaDisabled ||
                          _vm.loading,
                      },
                      on: { click: _vm.prepareLiquidity },
                    },
                    [
                      !_vm.loading
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("liquidity.cta")) +
                                "\n          "
                            ),
                          ])
                        : _c("span", [_c("Loading")], 1),
                    ]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "btn cyan",
                      on: { click: _vm.openConnectModal },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.connect_wallet")) +
                          "\n        "
                      ),
                    ]
                  ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cyan-cloud" },
        [_c("CloudCyanLiquidityLeft")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cyan-cloud2" },
        [_c("CloudCyanLiquidityRight")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }